// extracted by mini-css-extract-plugin
export default {"table":"sales-summary_table__g9J3I"};